/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import CustomEditCard from '../../../../common/components/CustomEditCard/CustomEditCard';
import CardContentTile from '../../../../common/components/CardContentTile/CardContentTile';
import { personalInfoType } from '../../../../common/interfaces/myProfile/personalDetails/personalInfo';
import { Box } from '@mui/system';
import PopupModalController from '../../../../common/Modals/PersonalDetails/PersonalInfoModal/PopupModalController';
import { themes } from '../../../../common/themes/themes';
import moment from 'moment';
import { baseDateFormatting } from '../../../../common/helper';

interface propsType {
  info: personalInfoType;
  hr_view?: boolean;
  trans?: any;
}

const PersonalInfoPresenter: React.FC<propsType> = ({ info, trans }) => {
  const [openModal, setOpenModal] = useState(false);
  return (
    <div>
      <CustomEditCard
        card_title={trans('Personal Information')}
        card_height="498px"
        onClick={() => {
          setOpenModal(true);
        }}
        showEditButton={true}
      >
        <Box style={{ marginBottom: '24px' }} />
        <CardContentTile
          tile_key={trans('First Name')}
          tile_value={info?.firstName}
        />
        <CardContentTile
          tile_key={trans('Last Name')}
          tile_value={info?.lastName}
        />
        <CardContentTile
          tile_key={trans('Date of Birth')}
          tile_value={moment(info?.DOB).format(baseDateFormatting)}
        />
        <CardContentTile tile_key={trans('Gender')} tile_value={info?.gender} />
        <CardContentTile
          tile_key={trans('Marital Status')}
          tile_value={info?.martialStatus}
        />
        <CardContentTile
          tile_key={trans('Country')}
          tile_value={info?.country}
        />
        <CardContentTile tile_key={trans('State')} tile_value={info?.state} />
        <CardContentTile
          tile_key={trans('Email')}
          tile_value={info?.email}
          value_color={themes.defaultInfoBlue}
        />
        <CardContentTile
          tile_key={trans('Phone')}
          tile_value={info?.phone}
          value_color={themes.defaultInfoBlue}
        />
        <CardContentTile
          tile_key={trans('Education')}
          tile_value={info?.education}
          value_color={themes.defaultInfoBlue}
        />
        <CardContentTile
          tile_key={trans('Religious')}
          tile_value={info?.religious}
          value_color={themes.defaultInfoBlue}
        />
        <CardContentTile
          tile_key={trans('Nationality')}
          tile_value={info?.nationalityName}
          value_color={themes.defaultInfoBlue}
        />
      </CustomEditCard>

      {/* Personal Info Modal */}

      {openModal && (
        <PopupModalController
          isModalOpen={openModal}
          closeModal={() => setOpenModal(false)}
          trans={trans}
        />
      )}
    </div>
  );
};

export default PersonalInfoPresenter;
